module.exports = __webpack_public_path__ + "img/tile_eight.4c84fc62.png";